import FAQ1 from './FAQ1'
export default FAQ1
